// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ml-3";
export var downloadButton = "_ml-4";
export var fileContainer = "_ml-9 _ml-7";
export var fileContainerBase = "_ml-7";
export var fileContainerFixedHeight = "_ml-8 _ml-7";
export var fileInfo = "_ml-5";
export var fileInfoWidthRestricted = "_ml-6";
export var fileType = "_ml-1";
export var fileTypeName = "_ml-2";
export var image = "_ml-0";
export var link = "_ml-b";
export var overflowEllipsis = "_ml-a";